module.exports = {
          srcSet: __webpack_public_path__ + "a8b3fe65bf616507fabca067978c6600-5214.png"+" 5214w",
          images:[ {path: __webpack_public_path__ + "a8b3fe65bf616507fabca067978c6600-5214.png",width: 5214,height: 4106}],
          src: __webpack_public_path__ + "a8b3fe65bf616507fabca067978c6600-5214.png",
          toString:function(){return __webpack_public_path__ + "a8b3fe65bf616507fabca067978c6600-5214.png"},
          
          width: 5214,
          height: 4106
        }